import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {Box, Button, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import NotifyMeModal from '../../notify-me-modal'

const QuickViewActions = ({
    styles,
    isNotifyMe,
    handleNotifyMe,
    isNotifyMeLoading,
    notifyMeError,
    isNotifyMeModalOpen,
    handleNotifyMeCloseModal,
    product,
    variant,
    notifyMeSuccessContent,
    disableAddToCart,
    cartInventoryMessage,
    handleCartItem,
    shouldShowShopSimilar,
    onShopSimilar,
    cartEditMode = false,
    isUpdating = false,
    updateError = '',
    isVariationDataLoading = false,
    notifyMeDrawerTitle,
    notifyMeRecommendation
}) => {
    const intl = useIntl()

    return (
        <>
            {isNotifyMe && (
                <Box {...styles.actionsContainer}>
                    <Button
                        key="notify-me-button"
                        onClick={handleNotifyMe}
                        isLoading={isNotifyMeLoading}
                        variant={'webPrimary'}
                        data-testid="qv-button-notify-me"
                        w={'100%'}
                    >
                        <FormattedMessage defaultMessage="Notify Me" id="pdp_notify_me_cta.label" />
                    </Button>
                    {notifyMeError && <Text {...styles.notifyMeError}>{notifyMeError}</Text>}
                    <NotifyMeModal
                        key="notify-me-modal"
                        isOpen={isNotifyMeModalOpen}
                        onClose={handleNotifyMeCloseModal}
                        product={product}
                        variant={variant}
                        showSuccessContent={notifyMeSuccessContent}
                        notifyMeDrawerTitle={notifyMeDrawerTitle}
                        notifyMeRecommendation={notifyMeRecommendation}
                    />
                </Box>
            )}
            {!isNotifyMe && shouldShowShopSimilar && !isVariationDataLoading && (
                <Box {...styles.actionsContainer}>
                    <Button
                        key="shop-similar-button"
                        onClick={onShopSimilar}
                        variant={'webPrimary'}
                        w={'100%'}
                        data-testid="qv-button-shop-similar"
                    >
                        {intl.formatMessage({
                            defaultMessage: 'Shop similar',
                            id: 'product_view.button.shop_similar'
                        })}
                    </Button>
                </Box>
            )}
            {!isNotifyMe && !shouldShowShopSimilar && (
                <Box {...styles.actionsContainer}>
                    {(cartInventoryMessage || updateError) && (
                        <Box {...styles.maxQtyErrorText} role="alert" marginBottom={2}>
                            {cartInventoryMessage || updateError}
                        </Box>
                    )}
                    <Button
                        isDisabled={disableAddToCart}
                        isLoading={isUpdating}
                        key="cart-button"
                        variant={'webPrimary'}
                        w={'100%'}
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            handleCartItem()
                        }}
                        data-testid="qv-button-add-to-cart"
                    >
                        {cartEditMode
                            ? intl.formatMessage({
                                  defaultMessage: 'Update',
                                  id: 'cart_edit.button.update'
                              })
                            : intl.formatMessage({
                                  defaultMessage: 'Add to Bag',
                                  id: 'product_view.button.add_to_cart'
                              })}
                    </Button>
                </Box>
            )}
        </>
    )
}

QuickViewActions.propTypes = {
    styles: PropTypes.object,
    isNotifyMe: PropTypes.bool,
    handleNotifyMe: PropTypes.func,
    isNotifyMeLoading: PropTypes.bool,
    notifyMeError: PropTypes.string,
    isNotifyMeModalOpen: PropTypes.bool,
    handleNotifyMeCloseModal: PropTypes.func,
    product: PropTypes.object,
    variant: PropTypes.object,
    notifyMeSuccessContent: PropTypes.bool,
    disableAddToCart: PropTypes.bool,
    cartInventoryMessage: PropTypes.string,
    handleCartItem: PropTypes.func,
    shouldShowShopSimilar: PropTypes.bool,
    onShopSimilar: PropTypes.func,
    cartEditMode: PropTypes.bool,
    isUpdating: PropTypes.bool,
    updateError: PropTypes.string,
    isVariationDataLoading: PropTypes.bool,
    notifyMeDrawerTitle: PropTypes.object,
    notifyMeRecommendation: PropTypes.object
}

export default QuickViewActions
